module.exports = __webpack_public_path__ + "img/american_express.a187af91.svg";